import { useHasSufficientViewportHeight } from './useHasSufficientViewportHeight.js';

export const useScrollableContainer = () => {
  const hasSufficientViewportHeight = useHasSufficientViewportHeight();

  const scrollableContainerId = hasSufficientViewportHeight
    ? 'data-table-container'
    : 'page-wrapper';

  const scrollableContainer = document.getElementById(scrollableContainerId);

  return scrollableContainer;
};
